const items = ["Track less.", "Decide better."];

export const Marquee = () => {
  const row = Array.from({ length: 6 }, (_, i) => (
    <span key={i} className="flex items-center gap-24 pr-24">
      <span className="font-display italic text-3xl md:text-5xl text-neutral-800 whitespace-nowrap">
        {items[0]}
      </span>
      <span className="h-2 w-2 rounded-full bg-coral shrink-0" aria-hidden="true" />
      <span className="font-display text-3xl md:text-5xl text-neutral-300 whitespace-nowrap">
        {items[1]}
      </span>
      <span className="h-2 w-2 rounded-full bg-teal shrink-0" aria-hidden="true" />
    </span>
  ));
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden bg-bone py-10 md:py-14 border-y border-neutral-200/70"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max">
        <div className="flex">{row}</div>
        <div className="flex">{row}</div>
      </div>
    </div>
  );
};
